import React from "react";
import { Routes as Switch, Route } from "react-router-dom";

import LandingPage from "../pages/LandingPage";

const RoutesWrapper: React.FC = () => {
  return (
    <Switch>
      <Route path="/:id" element={<LandingPage />} />
    </Switch>
  );
};

export default RoutesWrapper;
